import { render } from "./PageHeader.vue?vue&type=template&id=263b1082&scoped=true&ts=true"
import script from "./PageHeader.vue?vue&type=script&lang=ts"
export * from "./PageHeader.vue?vue&type=script&lang=ts"

import "./PageHeader.vue?vue&type=style&index=0&id=263b1082&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Hirofumi\\repository\\suite_totalling\\src\\html\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-263b1082"]])

export default __exports__